
import { defineComponent, PropType } from 'vue';
import {
  FEATURE_FLAGS,
  PARKING_SORT_OPTIONS,
} from '@white-label-configuration/constants';
import { closeModal, popstateEventHandler, pushModalState } from '@white-label-helper/helper-history-modal';
import { getFeatureFlag, trackLaunchDarklyExperimentImpression } from '@white-label-plugin/launch-darkly';
import { initFeefoReviews, updateFeefoStyles } from '@white-label-helper/init-feefo-reviews';
import { useScreenSize } from '@white-label-helper/shared-composables';

export default defineComponent({
  name: 'SearchParkingSort',

  components: {
    IconS3: () => import('@white-label-icon/icons-s3'),
    IconCheck: () => import('@white-label-icon/icon-check'),
    IconSort: () => import('@white-label-icon/icon-sort'),
  },

  props: {
    sortOptions: {
      type: Array as PropType<string[]>,
      required: true
    },

    value: {
      type: String,
      required: true
    }
  },

  setup() {
    const { isMobileResolution, isTabletResolution } = useScreenSize();
    return { isMobileResolution, isTabletResolution };
  },

  data() {
    return {
      removePopstateHandler: null as any,
      listShown: false,
      PARKING_SORT_OPTIONS
    };
  },

  computed: {
    isScrollLocked(): boolean {
      return (this.isMobileResolution || this.isTabletResolution) && this.listShown;
    }
  },

  watch: {
    listShown: {
      handler(value) {
        if (value) {
          pushModalState('sort');
          this.$nextTick(() => {
            const sortList = this.$refs.sortList as unknown as HTMLElement | undefined;
            sortList?.querySelector<HTMLElement>('.search-parking-sort__list-item')?.focus();
          });
        } else {
          closeModal('sort');
        }
      }
    }
  },

  mounted() {
    this.removePopstateHandler = popstateEventHandler('sort', () => this.listShown = false);
    trackLaunchDarklyExperimentImpression(this.$gtm, FEATURE_FLAGS.CRO_1272_REINTRODUCE_SORT_BY_PRICE_OPTION, 'cro-1272');
  },

  beforeDestroy() {
    if (this.removePopstateHandler) {
      this.removePopstateHandler();
    }
  },

  methods: {
    onToggleSort(): void {
      const shouldOpen = !this.listShown;

      this.listShown = shouldOpen;

      if (shouldOpen) {
        this.$launchDarkly.track('sort_click');
      }
    },

    onOptionSelect(option: string): void {
      this.$emit('input', option);
      this.listShown = false;

      if (
        option === PARKING_SORT_OPTIONS.PRICE ||
        option === PARKING_SORT_OPTIONS.PRICE_HIGH_LOW
      ) {
        this.$launchDarkly.track('sort_price_click');
      }

      if (!getFeatureFlag('ecom-3559-fee-fo-api-integration')) {
        initFeefoReviews();
        updateFeefoStyles();
      }

      this.$nextTick(() => {
        const sortToggleButton = this.$refs.sortToggleButton as unknown as HTMLElement | undefined;
        sortToggleButton?.focus();
      });
    }
  }
});
